import React from 'react';

function ExportQueryOutput({ output, loading }) {
  if (loading) {
    return (
      <div className="export-query-output mt-4">
        <p className="text-muted mb-0">Preparing CSV export…</p>
      </div>
    );
  }

  if (!output) {
    return null;
  }

  return (
    <div className="export-query-output mt-4">
      {output.error ? (
        <p className="export-query-output__error text-danger mb-0">{output.error}</p>
      ) : null}
      {output.success ? (
        <p className="text-success mb-0">
          Downloaded {output.fileName}
          {Number.isFinite(output.rowCount) ? ` (${output.rowCount} rows)` : ''}.
        </p>
      ) : null}
    </div>
  );
}

export default ExportQueryOutput;
